import React from "react"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"

import { GTM_PROJECT_CATEGORY } from "../../utils/constants"
import { getGtmUserType, fireGtmEvent } from "../../utils/functions"
// import { Zoom } from "@material-ui/core"

const processImageUrl = (imageUrl, parameters) => {
  // if empty or "0" (as in data)
  if (!imageUrl || imageUrl === "0") {
    return `https://images.contentstack.io/v3/assets/bltdf38de19a247654d/bltc60fa1acf6b4cde4/615aa48d6d2d465121b1c139/store-default.jpeg?${parameters}`
  }

  // check if the imageUrl is a contentstack url
  if (imageUrl.includes("images.contentstack.io")) {
    return `${imageUrl}?${parameters}`
  }

  // for non contentstack image URLs
  return imageUrl
}

export default function CarouselWrapper(props) {
  // console.log("props flex card",props)
  const countryURL = props.countryUrl
  const ctaText = props.countryUrl === "/th/th/" ? "สั่งซื้อเลย" : "Order Now"
  // console.log("ctaText",ctaText)

  const lazyLoadImage = props.lazyLoadImage
  const enableProgressiveImageLoading = props.enableProgressiveImageLoading
  const title = props.dataTitle ? props.dataTitle : "Vegetarian"
  const carouselLabel = props.data
    ? props.data
        .map(function (elem) {
          return elem.name
        })
        .join("|")
    : "Asian"
  const positionLabelMerchants = props.data
    .map(function (elem, index) {
      return index + 1
    })
    .join("|")
  const positionLabel = props.numberOfCarousels ? props.numberOfCarousels : 1
  const gtmUserType = getGtmUserType()
  const cardData = props.data.map((x, index) => {
    let storeName = x.name ? x.name.replace(/[-(_)]/g, "") : null
    storeName = storeName.replace("  ", " ")
    let promotion = x.promotions ? x.promotions : ""
    // console.log("promotions",x.promotions)
    let promotionCode = promotion ? x.promotions[0].code : ""
    let storeTags = []
    const ctaText = countryURL === "/th/th/" ? "สั่งซื้อเลย" : "Order Now"

    let storeCategoryObj = x.categories.length ? x.categories[0] : [{}]
    let storeCategory = storeCategoryObj.name || ""

    if (x.store_tags) {
      x.store_tags.forEach((tag, tagIndex) => {
        storeTags.push(tag.name)
      })
    }
    return {
      attractText: "",
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      couponBoxCtaText: "",
      couponBoxLabel: "",
      cta: ctaText,
      currencyCode: "",
      discount: "",
      // discount: x.promotions?x.promotions[0].description:"",
      hidden: "",
      image: processImageUrl(
        x.image_url,
        "?height=180&quality=80&format=jpg&auto=webp"
      ),
      lowResolutionImageUrl: processImageUrl(
        x.image_url,
        "?height=180&quality=10&format=jpg&auto=webp"
      ),
      labelColor: "",
      location: "",
      mobileAppImageURL: "",
      newTab: "FALSE",
      position: "",
      price: x.price,
      priceClarification: "",
      priceDisclaimer: "",
      primaryLabel: promotionCode ? promotionCode : "",
      productID: "",
      productType: "",
      promotionCouponCode: promotionCode ? promotionCode : "",
      promotionTnC:
        x.promotions && x.promotions[0].description
          ? x.promotions[0].description
          : "",
      rating: "",
      secondaryImage: "",
      secondaryLabel: "",
      star: "",
      subtitle: storeTags.length ? storeTags.join(", ") : "",
      subtitleExpandCtaText: x.promotions ? "know more" : "",
      timer: "",
      title: x.name,
      imageAlt: `${storeCategory} food at ${x.name}`,
      url: x.store_url
        ? x.store_url
        : `https://www.airasia.com/food/my/restaurant/${storeName
            .split(" ")
            .join("-")
            .toLowerCase()}`,
    }
  })
  return (
    <Carousel
      accessible
      cardConfig={{
        focusEffect: true,
      }}
      data={[...cardData]}
      heading={{
        cardCount: "5",
        gtmParameters: {
          event: "trackEventNoEcommerce",
          eventActionClick: "click",
          eventActionView: "view",
          eventCategory: `${GTM_PROJECT_CATEGORY}|carousel|${title}|${positionLabel}`,
          eventLabelCardClick: `${GTM_PROJECT_CATEGORY}|{{cardtitle}}|{{cardposition}}`,
          eventLabelHeadlineClick: `${gtmUserType}|headline|{{headline}}`,
          eventLabelView: `${carouselLabel}|${positionLabelMerchants}`,
          // eventLabelView: `${GTM_PROJECT_CATEGORY}|${gtmUserType}`
        },
        headline: "",
        // headlineStyle: 'h2',
        layoutName: "lob_widget",
        showMoreURL: "",
        subHeadline: "",
        widgetID: "",
        widgetName: "Hotel Location Widget",
        widgetWidth: "3",
      }}
      gtmConsumerName={props.gtmConsumerName}
      fireGtm={obj => {
        fireGtmEvent(obj)
      }}
      isLoading={false}
      handleClick={function noRefCheck() {}}
      templateType="productCard"
      theme="AIRASIA_CLASSIC"
      lazyLoadImage={lazyLoadImage}
      enableProgressiveImageLoading={enableProgressiveImageLoading}
    />
  )
}
